<template>
  <Batteries no-filter tab :query="{ projectId: project.id }"></Batteries>
</template>

<script>
import Batteries from "@/components/Batteries/index.vue";
export default {
  components: { Batteries },
  props: {
    project: {
      type: Object,
    },
  },
};
</script>

<style></style>
